'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.initialCompanyProfileState = undefined;

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _CompanyOverview = require('./records/CompanyOverview');

var _CompanyOverview2 = _interopRequireDefault(_CompanyOverview);

var _actionTypes = require('../constants/actionTypes');

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialCompanyProfileState = new _CompanyOverview2.default({});

var companyProfile = function companyProfile() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialCompanyProfileState;
	var _ref = arguments[1];
	var type = _ref.type,
	    value = _ref.value;

	switch (type) {
		case types.RECEIVE_COMPANY_INFO:
			if (!value) {
				return state;
			}
			return new _CompanyOverview2.default(_immutable2.default.fromJS(value));
		case types.TOGGLE_FOLLOW_COMPANY:
			return state.update('followedByUser', function (f) {
				return !f;
			}).set('followedByUserRequested', false);
		case types.TOGGLE_FOLLOW_COMPANY_REQUEST:
			return state.set('followedByUserRequested', true).set('followedByUserRequestError', '');
		case types.TOGGLE_FOLLOW_COMPANY_ERROR:
			return state.set('followedByUserRequested', false).set('followedByUserRequestError', value);
		case types.BLOCK_COMPANY_SUCCESS:
			return state.update('blockedByUser', function (f) {
				return !f;
			}).set('blockCompanyRequested', false);
		case types.BLOCK_COMPANY_REQUEST:
			return state.set('blockCompanyRequested', true).set('blockCompanyRequestError', '');
		case types.BLOCK_COMPANY_ERROR:
			return state.set('blockCompanyRequested', false).set('blockCompanyRequestError', value);
		default:
			return state;
	}
};

exports.initialCompanyProfileState = initialCompanyProfileState;
var _default = companyProfile;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(initialCompanyProfileState, 'initialCompanyProfileState', 'src/reducers/companyProfile.js');

	__REACT_HOT_LOADER__.register(companyProfile, 'companyProfile', 'src/reducers/companyProfile.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/reducers/companyProfile.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/reducers/companyProfile.js
// module id = 2ODj
// module chunks = 62 63